'use strict';

module.exports = {
  HTML_END: 'HTML_END',
  OPEN_TAG_START: '<',
  TAG_END: '>',
  SELF_CLOSING: '/>',
  CLOSING_TAG_START: '</',
  SPACE: ' '
};